/**
 * 商品比价 相似款
 * @author wanghui@gwdang.com
 */
import { docCookies as Cookies } from '../js/utils/utils';


const signParams = function (data) {
    const fp = Cookies.getItem('fp');
    const keys = Object.keys(data);
    keys.sort();

    let t = [];
    keys.forEach(k => {
        t.push(`${k.toString()}=${data[k]}`);
    });

    let s = t.join('*');
    s += `*fp=${fp}`;
    console.log('sign params 123');
    console.log(s);

    const md5 = require('md5');
    return md5(s);
}

const ProductSame = {
    getList (dp_id, title, price = 0, from = 'trend') {
        const timestamp = (new Date()).getTime();
        const str = signParams({
            dp_id,
            price,
            title,
            timestamp
        });

        console.log(str);
        return new Promise((resolve, reject) => {
            $.ajaxSetup({crossDomain: true, xhrFields: {withCredentials: true}});
            $.ajax({
                url: (location.hostname.includes('bijiago.com') ? '/bjg': '') + '/product/aj_same',
                type: 'GET',
                data: {
                    dp_id,
                    title,
                    price,
                    from,
                    timestamp,
                    str
                },
                dataType: 'json',
                success (resp) {
                    if (! resp.code) {
                        resolve(resp.data);
                    } else {
                        reject(resp);
                    }
                }
            })
        });
    }
};

export default ProductSame;